export default __webpack_public_path__ + "static/media/Groupphoto1.eb5bb88c.png";